import type { HeroProps } from '@/components/PolicyTwo/Hero';
import { sharedConfig } from '@/pageConfig/shared';
import og from '@/static/assets/transparency/transparency_report_og.png';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/PolicyTwo/policyTwo__en-FR.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

export interface Config extends BasePageConfig {
  hero: HeroProps;
}

export const config: Config = {
  layout: { ...sharedConfig['en-FR'].layout, showAskUsAnything: true },
  seo: {
    ...sharedConfig['en-FR'].seo,
    title: 'Policy 2.0 by Lemonade Insurance France from 4 €/month',
    description:
      'Policy 2.0 by Lemonade: A simplified and digitized insurance policy. Check out the world’s first open source insurance policy.',
    ogImage: og.src,
  },
  hero: {
    title: 'World’s First Open Source\nInsurance Policy',
    subtitle:
      'Policy 2.0 is a radically simplified, modernized, and digitized insurance policy. This means you can actually read and understand it!',
    ctaLabel: 'read the policy',
  },
  MDXContent: content as DocumentTypes,
};
